import { IsEmpty } from "../../utils/helper";

const formatErrorMessage = (key) => {
  return `${key
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase())} is required`;
};


export default function validateFields(data, customFields = []) {
  let errors = {};

  Object.keys(data).forEach((key) => {
    const value = data[key];
    const fieldConfig = customFields.find((f) => f.name === key);
    const type = fieldConfig?.type || "text";
    const isRequired = fieldConfig?.required ?? false;

    if (isRequired) {
      if (
        (type === "checkbox" && !value) ||
        (type !== "checkbox" && (!value || value.toString().trim() === ""))
      ) {
        errors[key] = formatErrorMessage(key);
        return;
      }
    } else {
      if (!value || value.toString().trim() === "") {
        return;
      }
    }

    switch (type) {

      case "text": {
        const textValue = typeof value === "string" ? value.trim() : value;
        const nameFields = ["first_name", "last_name", "team_type", "state", "country_region", "team_type"];
        const companyFields = ["company_name", "industry", "industry_focus", "parent_company",];

        // 🔤 Common text validation for name/company-like fields
        if (nameFields.includes(key)) {
          const nameRegex = /^[A-Za-z\s'-]+$/; // letters, spaces, hyphens, apostrophes
          if (textValue.length < 3 || textValue.length > 30) {
            errors[key] = `${fieldConfig.label} must be between 3 and 30 characters`;
          } else if (!nameRegex.test(textValue)) {
            errors[key] = `${fieldConfig.label} must only contain letters`;
          }
        }

        if (companyFields.includes(key)) {
          const companyRegex = /^[A-Za-z0-9\s'-]+$/; // letters, numbers, spaces, hyphens, apostrophes
          if (textValue.length < 3 || textValue.length > 30) {
            errors[key] = `${fieldConfig.label} must be between 3 and 30 characters`;
          } else if (!companyRegex.test(textValue)) {
            errors[key] = `${fieldConfig.label} must only contain letters and numbers`;
          }
        }

        // 🌐 Website validation
        if (key === "website") {
          // allow http(s):// or www., then domain, TLD 2-10 chars
          const websiteRegex = /^(https?:\/\/)?(www\.)?[A-Za-z-]+(\.[A-Za-z]{2,10})+$/;
          if (!websiteRegex.test(textValue)) {
            errors[key] = "Please enter a valid website URL (e.g., https://example.com)";
          }
        }

        // 📮 Zip / Pin Code validation
        if (key === "pin_code") {
          const pinRegex = /^\d{5,6}$/;
          if (!pinRegex.test(textValue)) {
            errors[key] = "Zip/Pin Code must be 5 or 6 digits only";
          }
        }

        if (key === "address1") {
          // allow alphabets, numbers, space, . , - / ' ( ) & #
          const addressRegex = /^[A-Za-z0-9\s.,\-\/'()&#]+$/;
          if (!addressRegex.test(textValue)) {
            errors[key] = "Please enter a valid address (letters, numbers and . , - / ' ( ) & # allowed)";
          }
        }


        break;
      }

      case "email":
        // if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        //   errors[key] = "Invalid email address";
        // }

        const email = value?.trim();
        if (IsEmpty(email)) {
          errors.email = "Email is required";
        } else {
          const trimmedEmail = email.trim();

          const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

          if (!emailRegex.test(trimmedEmail)) {
            errors.email = "Invalid email format";
          } else if (trimmedEmail.length > 254) {
            errors.email = "Email is too long";
          } else if (trimmedEmail.includes("..")) {
            errors.email = "Email cannot contain consecutive dots";
          } else if (trimmedEmail.startsWith(".") || trimmedEmail.includes("@.") || trimmedEmail.includes(".@")) {
            errors.email = "Invalid email format";
          }
        }
        break;

      case "tel": {
        const selectedCountry = data?.country_region;
        let phoneWithCountryCode =
          value?.startsWith("+") && value;
          
        if (!value) {
          errors[key] = formatErrorMessage(key);
        } else if (
          !value.startsWith("+") &&
          !/^\d{10}$/.test(value)
        ) {
          errors[key] = `${fieldConfig.label} must be 10 digits and start with country code`;
        } else if (
          !/^\+1\d{10}$|^\+44\d{10}$|^\+1\d{10}$/.test(phoneWithCountryCode)
        ) {
          errors[key] = `Invalid ${fieldConfig.label}!`;
        } else if (
          (selectedCountry === "United States of America" &&
            !value.startsWith("+1")) ||
          (selectedCountry === "Canada" &&
            !value.startsWith("+1")) ||
          (selectedCountry === "United Kingdom" &&
            !value.startsWith("+44"))
        ) {
          let correctCode =
            selectedCountry === "United Kingdom" ? "+44" : "+1";
          errors[key] = `${fieldConfig.label} must start with the correct country code (${correctCode}) for ${selectedCountry}.`;
        } else {
          // This line attempts to modify data.phone_number directly, which is not ideal
          // for a generic validator. The `handleSubmit` function should format the phone number
          // when submitting. For now, we'll keep it as is but note for potential refactor.
          data.phone_number = phoneWithCountryCode;
        }
        break;
      }

      case "password":
        if (/\s/.test(value)) {
          errors[key] = "Password must not contain spaces";
        } else if (value.length < 8) {
          errors[key] = "Password must be at least 8 characters long";
        }
        break;

      case "confirm_password":
        if (value !== data.password) {
          errors[key] = "Passwords do not match";
        }
        break;

      case "number":
        if (isNaN(value)) {
          errors[key] = "This field must be a valid number";
        } else if (value < 0) {
          errors[key] = "This field must be a positive number";
        }
        break;

      case "checkbox":
        if (!value) {
          errors[key] = "You must agree to continue";
        }
        break;

      default:
        break;
    }
  });

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
}



